const atualizarProdutos = (state, produtos) => {
    state.produtos = produtos || [];
    state.ultimaAtualizacaoLista = new Date();
    state.listaCompletaCarregada = true;
}

const limparProdutos = (state) => {
    state.produtos = [];
    state.ultimaAtualizacaoLista = null;
    state.listaCompletaCarregada = false;
}

const adicionarProdutos = (state, produtos) => {
    const produtosExistentes = new Set(state.produtos.map((produto) => produto.id));
    const novosProdutos = (produtos || []).filter((produto) => !produtosExistentes.has(produto.id));
    state.produtos = state.produtos.concat(novosProdutos);
    state.ultimaAtualizacaoLista = new Date();
}

const atualizarListaProdutos = (state, listaProdutos) => {
    atualizarProdutos(state, listaProdutos);
}

const atualizarServicos = (state, listaServicos) => {
    atualizarProdutos(state, listaServicos);
}
const atualizarServicosInterno = (state, listaServicosInterno) => {
    atualizarProdutos(state, listaServicosInterno);
}

const atualizarProduto = (state, produto) => {
    state.produto = produto;
}

const addProduto = (state, produto) => {
    const novoProduto = JSON.parse(JSON.stringify(produto));
    state.produtos.push(novoProduto);
}

const updateProduto = (state, produto) => {
    const item = state.produtos.find(item => item.id === produto.id);
    if (item) {
        Object.assign(item, produto);
    } else {
        state.produtos.push(JSON.parse(JSON.stringify(produto)));
    }
}

export default {
    atualizarProdutos,
    limparProdutos,
    adicionarProdutos,
    atualizarProduto,
    addProduto,
    updateProduto,
    atualizarListaProdutos,
    atualizarServicos,
    atualizarServicosInterno
}
